import React from 'react';
import clsx from 'clsx';

const STATUS_COLORS = {
  received: 'bg-surface text-ink',
  archived: 'bg-ink text-white',
  check_required: 'bg-warn text-ink',
  reviewed: 'bg-ok text-white',
  sent_to_accountant: 'bg-accent text-white',
  no_pdf: 'bg-danger text-white',
  failed: 'bg-danger text-white',
  ignored: 'bg-muted text-white',
};

const STATUS_LABELS = {
  received: 'recibido',
  archived: 'archivado',
  check_required: 'por revisar',
  reviewed: 'revisado',
  sent_to_accountant: 'enviado',
  no_pdf: 'sin pdf',
  failed: 'fallido',
  ignored: 'ignorado',
};

export function StatusBadge({ status, className }) {
  const cls = STATUS_COLORS[status] || 'bg-surface text-ink';
  const label = STATUS_LABELS[status] || status;
  return (
    <span
      data-testid={`status-${status}`}
      title={status}
      className={clsx(
        'inline-block px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide2 leading-tight',
        cls,
        className
      )}
    >
      {label}
    </span>
  );
}

export function ReviewBadge({ active }) {
  if (!active) return null;
  return (
    <span className="inline-block px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide2 bg-warn text-ink">
      review
    </span>
  );
}

// Flags duplicated by other badges (status badge already shows these).
const HIDDEN_FLAGS = new Set(['check', 'check_required', 'needs_review', 'review']);

export function FlagBadges({ flags }) {
  const visible = (flags || []).filter((f) => !HIDDEN_FLAGS.has(String(f).toLowerCase()));
  if (!visible.length) return null;
  return (
    <div className="flex gap-1 flex-wrap">
      {visible.map((f) => (
        <span
          key={f}
          className="inline-block px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide2 border border-ink/80"
        >
          {f}
        </span>
      ))}
    </div>
  );
}

export function DuplicateBadge({ count }) {
  if (!count) return null;
  return (
    <span
      data-testid="dup-badge"
      title="Documento recibido varias veces"
      className="inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide2 bg-warn text-ink"
    >
      🔁 {count}
    </span>
  );
}
